import api from '@/utils/api'

export default {
  state: () => ({
    runningLinesList: null,
  }),
  mutations: {
    setRunningLinesList(state, payload) {
      state.runningLinesList = payload
    },
  },
  getters: {},
  actions: {
    async fetchRunningLinesList({ commit }) {
      const res = await api.http.get('admin/running-line-banners')
      commit('setRunningLinesList', res?.data?.data)
      return res?.data?.data
    },

    async createRunningLine(_, formData) {
      await api.http.post('admin/running-line-banners', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },

    async updateRunningLine(_, {formData, id}) {
      await api.http.post(`admin/running-line-banners/${id}/update`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },

    async deleteRunningLine(_, id) {
      await api.http.delete(`admin/running-line-banners/${id}/delete`)
    },

    async getRunningLine(_, id) {
      const res = await api.http.get(`admin/running-line-banners/${id}`)
      return res?.data?.data
    },

    async uploadImage(_, formData) {
      const res = await api.http.post('admin/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return res?.data?.data
    },
  },
  namespaced: true,
}


